import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';
//import {push} from "connected-react-router"
import {
  getArtisanCategoriesSuccessAction,
  setArtisanCategoriesIsLoadingAction,
  createArtisanCategorySuccessAction,
  updateArtisanCategorySuccessAction,
  setArtisanCategoriesCountAction,
  getArtisanParentCatgoriesSuccesAction
} from './Actions';
import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from '../notifications/Actions';
import * as api from './Api';
import { push } from 'connected-react-router';

function* createArtisanCategory({ payload }) {
  try {
    yield put(setArtisanCategoriesIsLoadingAction(true));
    const response = yield call(api.createArtisanCategory, { ...payload });
    const { data } = response;
    const category = data;
    yield put(createArtisanCategorySuccessAction(category));
    yield put(
      newSuccessNotificationAction(`Created Category : ${category.name}`)
    );
    yield put(push('/job/artisan-categories'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanCategoriesIsLoadingAction(false));
  }
}

function* updateAtrisanCategory({ payload: { id, formData } }) {
  try {
    yield put(setArtisanCategoriesIsLoadingAction(true));
    delete formData._id;
    const response = yield call(api.updateArtisanCategory, id, formData);
    const { data } = response;
    const updatedCategory = data;
    yield put(updateArtisanCategorySuccessAction(updatedCategory));
    yield put(push('/job/artisan-categories'));
    yield put(
      newSuccessNotificationAction(`Updated Category : ${updatedCategory.name}`)
    );
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanCategoriesIsLoadingAction(false));
  }
}

function* getArtisanCategories({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    sort: 'name',
    dir: 'asc',
    filterBy: [{ type: '1' }]
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setArtisanCategoriesIsLoadingAction(true));

    const response = yield call(api.getArtisanCategories, body);
    const { data } = response;

    console.log('fataaa', data);
    const count = data.count;
    const artisanCategories = data.content;

    yield put(getArtisanCategoriesSuccessAction(artisanCategories));
    yield put(setArtisanCategoriesCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanCategoriesIsLoadingAction(false));
  }
}

function* getArtisanParentCategories({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    sort: 'name',
    dir: 'asc'
  };

  const body = { ...defData, ...payload };
  try {
    yield put(setArtisanCategoriesIsLoadingAction(true));

    const response = yield call(api.getParentCategories, body);
    const { data } = response;
    console.log(response);
    const count = data.count;
    const artisanCategories = data.content;

    yield put(getArtisanParentCatgoriesSuccesAction(data));
    // yield put(setArtisanCategoriesCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanCategoriesIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.CREATE_JOB_ARTISAN_CATEGORY, createArtisanCategory);
  yield takeLatest(actions.UPDATE_JOB_ARTISAN_CATEGORY, updateAtrisanCategory);
  yield takeLatest(
    actions.GET_JOB_ARTISAN_PARENT_CATEGORIES,
    getArtisanParentCategories
  );
  yield takeLatest(actions.GET_JOB_ARTISAN_CATEGORIES, getArtisanCategories);
}
